/*
 * SPDX-FileCopyrightText: 2026 The HedgeDoc developers (see AUTHORS file)
 *
 * SPDX-License-Identifier: AGPL-3.0-only
 */
import type { NoteTreeEntryInterface } from '@hedgedoc/commons'

/**
 * Sorts notes so that the most recently changed note comes first, without changing the given list.
 *
 * @param notes The notes to sort
 * @return A new list of the notes, sorted by the time they were last changed
 */
export const sortByLastChangedDesc = (notes: NoteTreeEntryInterface[]): NoteTreeEntryInterface[] =>
  [...notes].sort((a, b) => b.lastChangedAt.localeCompare(a.lastChangedAt))
